import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { X } from "lucide-react";
import styles from "./BulkInternalNotes.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberUtils";

type TBulkInternalNotesItem = {
	data: EventInventoryRecord;
	onRemove?: (listingId: number) => void;
};

const BulkInternalNotesItem = ({ data, onRemove }: TBulkInternalNotesItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	return (
		<div className={styles.singleListing}>
			<div className={styles.secRowSeat}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						<div>Qty: {data.Quantity}</div>
					</div>
				</div>
			</div>
			<div className={styles.costLabel}>{formatCurrency(data.Item_Cost)}</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkInternalNotesItem;
